import { render, staticRenderFns } from "./caCumule.vue?vue&type=template&id=f56c9c06&"
import script from "./caCumule.vue?vue&type=script&lang=js&"
export * from "./caCumule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports